// extracted by mini-css-extract-plugin
export default {"wrapper":"SaveProfileSection_wrapper__cke26"};